module.exports = __webpack_public_path__ + "media/images/new_home/claimed-424f6f049426bbf63f390be4c24ff0ca.png";